var map = {
	"./AIA.png": 54,
	"./AIG.png": 55,
	"./AXA.png": 56,
	"./Aioi.png": 57,
	"./Bangkok.png": 58,
	"./CHUBB.png": 59,
	"./Charan.png": 60,
	"./Cigna.png": 61,
	"./Deves.png": 62,
	"./Dhipaya.png": 63,
	"./FPG.png": 64,
	"./Falcon.png": 65,
	"./Indara.png": 66,
	"./IndaraPLC.png": 67,
	"./Jaymart.png": 68,
	"./KPI.png": 69,
	"./KWG.png": 70,
	"./LMG.png": 71,
	"./MSIG.png": 72,
	"./MuangThai.png": 73,
	"./NSI.png": 74,
	"./Navakij.png": 75,
	"./New India.png": 76,
	"./SouthEast.png": 77,
	"./Sunday.png": 78,
	"./THAIPAIBOON.png": 79,
	"./THAIPAT.png": 80,
	"./THAISRI.png": 81,
	"./TSI.png": 82,
	"./Thanachart.png": 83,
	"./TokioMarine.png": 84,
	"./Tune.png": 85,
	"./Viriyah.png": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;